<div class="row">
  <div class="col-md-12">
    <div class="content" style="background-color: white;">
      <div class="row">
        <div class="col-md-12 justify-content-center contents background-formulario">
          <div class="col-md-12 mb-5">
            <h1>Cadastre-se</h1>
          </div>
          <form *ngIf="!sucesso" id="formLogin" [formGroup]="formCadastrar" autocomplete="off">
            <div class="form-group col-md-12 mb-2"
                 [ngClass]="{'is-invalid': formCadastrar.controls['nome'].touched && formCadastrar.controls['nome'].errors?.required}"
                 *ngIf="cpfCnpj">
              <label for="username">Nome</label>
              <input type="text" formControlName="nome"
                     placeholder="Digite seu nome"
                     class="form-control" id="nome" autocomplete="off">
            </div>

            <div class="form-group col-md-2 mb-2" [ngClass]="{'is-invalid': formCadastrar.controls['cpf'].touched && formCadastrar.controls['cpf'].errors?.required}" *ngIf="cpfCnpj">
              <label for="cpf">CPF</label>
              <input type="text" mask="000.000.000-00" formControlName="cpf"
                     placeholder="000.000.000-00"
                     class="form-control" id="cpf" autocomplete="off">
            </div>
            <div class="form-group col-md-10 mb-2" [ngClass]="{'is-invalid': formCadastrar.controls['email'].touched && formCadastrar.controls['email'].errors?.required}">
              <label for="username">Email</label>
              <input type="text" formControlName="email" placeholder="Digite seu email"
                     aria-autocomplete="none" class="form-control" id="username" autocomplete="off">
            </div>
            <span id="nome-error-required" class="error mensagem-erro"
                  *ngIf="formCadastrar.controls['email'].touched && formCadastrar.controls['email'].errors?.required">O email não pode ser vazio <br></span>
            <span id="nome-error-min-length" class="error mensagem-erro"
                  *ngIf="formCadastrar.controls['email'].touched && formCadastrar.controls['email'].errors?.email">Email com formato inválido.<br></span>
            <div class="form-group col-md-6 mb-2" [ngClass]="{'is-invalid': formCadastrar.controls['senha'].touched && formCadastrar.controls['senha'].errors?.required}">
              <label for="password">Senha</label>
              <input type="password" formControlName="senha" class="form-control" id="password"
                     placeholder="Digite sua senha"
                     autocomplete="off">
              <span id="senha-error-required" class="error mensagem-erro"
                    *ngIf="formCadastrar.controls['senha'].touched && formCadastrar.controls['senha'].errors?.required"
              >A senha não pode ser vazia <br></span>
              <span id="senha-error-min-length" class="error mensagem-erro"
                    *ngIf="formCadastrar.controls['senha'].touched && formCadastrar.controls['senha'].errors?.maxlength"
              >A senha tem que ter até 20 caracteres.<br></span>
            </div>
            <div class="form-group col-md-6 mb-2">
              <label for="confirmacaoSenha" [ngClass]="{'is-invalid': formCadastrar.controls['confirmacaoSenha'].touched && formCadastrar.controls['confirmacaoSenha'].errors?.required}">Confirmação Senha</label>
              <input type="password" formControlName="confirmacaoSenha" placeholder="Confirme sua senha"
                     class="form-control padding115" id="confirmacaoSenha"
                     autocomplete="off">
              <span id="confirmacaoSenha-error-required" class="error mensagem-erro"
                    *ngIf="formCadastrar.controls['senha'].touched && formCadastrar.controls['senha'].errors?.required"
              >A senha não pode ser vazia <br></span>
              <span id="confirmacaoSenha-error-min-length" class="error mensagem-erro"
                    *ngIf="formCadastrar.controls['senha'].touched && formCadastrar.controls['senha'].errors?.maxlength"
              >A senha tem que ter até 20 caracteres.<br></span>
            </div>
            <div class="form-group col-md-12 mb-5">
              <label for="plano">Plano</label>
              <ng-select [items]="planos"
                         bindLabel="nome"
                         bindValue="id"
                         formControlName="plano"
                         [clearable]="false"
                         placeholder="Selecione o plano"
                         id="plano">
                <ng-template ng-label-tmp let-item="item">
                  {{item.nome}} - (R${{item.preco}})
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{item.nome}} - (R${{item.preco}})
                </ng-template>
              </ng-select>
            </div>
          </form>
          <div class="row text-center align-content-center align-items-center">
            <input *ngIf="!sucesso" value="Cadastrar" [ngClass]="{'corBotaoIMed': tipoSaas == '9f5f628b-6d4b-42d0-b3bb-8c5417e8d64d'}" (click)="salvar()" class="btn btn-block btn-primary py-2 align-content-center text-center col-md-4">
          </div>
          <span class="d-block text-right my-4 text-muted">Já tenho cadastro - <a href="auth/login/{{tipoSaas}}">Login</a></span>
        </div>
      </div>
    </div>
  </div>
</div>
